import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const AlarmIconSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_127_120)">
            <path
                d="M36.8335 25.1667C36.8335 18.2868 31.3887 12.6705 24.5835 12.3625V10H23.4169V12.3625C16.6117 12.6705 11.1669 18.2868 11.1669 25.1667C11.1669 28.7297 12.6287 31.9555 14.9807 34.283L12.4864 37.0247L13.3485 37.8098L15.844 35.0682C18.063 36.8998 20.905 38.0012 24.0002 38.0012C27.0954 38.0012 29.9374 36.8998 32.1564 35.0682L34.6519 37.8098L35.514 37.0247L33.0197 34.283C35.3717 31.9555 36.8335 28.7297 36.8335 25.1667ZM12.3335 25.1667C12.3335 18.7337 17.5672 13.5 24.0002 13.5C30.4332 13.5 35.6669 18.7337 35.6669 25.1667C35.6669 31.5997 30.4332 36.8333 24.0002 36.8333C17.5672 36.8333 12.3335 31.5997 12.3335 25.1667ZM31.93 11.5552L32.518 10.5483C34.4384 11.6695 36.0974 13.136 37.4507 14.9047L36.5232 15.6128C35.2644 13.9643 33.7185 12.6005 31.93 11.5552ZM11.4574 15.6397L10.5287 14.9338C11.8832 13.1535 13.5469 11.6788 15.473 10.553L16.0622 11.5598C14.2679 12.6087 12.7197 13.9818 11.4574 15.6397ZM24.5835 23.6687L30.1334 26.9983L29.5325 27.9982L23.4157 24.3278V15.831H24.5824V23.6675L24.5835 23.6687Z"
                fill="currentColor" />
        </g>
        <defs>
            <clipPath id="clip0_127_120">
                <rect width="28" height="28" fill="currentColor" transform="translate(10 10)" />
            </clipPath>
        </defs>
    </svg>
)
const AlarmIcon: React.FC<SvgIconProps> = ({ style, ...props }) => (
    <SvgIcon {...props} style={{ fontSize: '40px', ...style }}>
        {AlarmIconSvg}
    </SvgIcon>
)
export default AlarmIcon
